<script lang="ts">
  import { dialogData } from "stores";
  import { ButtonComponent, CheckboxComponent } from "ui";
  import RadioField from "../../UI/RadioField.svelte";

  // Demo-only local state — NOT persisted anywhere.
  let trainingLocation: "home" | "gym" = "gym";

  const equipmentOptions: Array<{ key: string; label: string }> = [
    { key: "dumbbells", label: "Dumbbells" },
    { key: "barbell", label: "Barbell" },
    { key: "resistance_bands", label: "Resistance bands" },
    { key: "pullup_bar", label: "Pull-up bar" },
    { key: "kettlebell", label: "Kettlebell" },
    { key: "bench", label: "Bench" },
    { key: "cable_machine", label: "Cable machine" },
    { key: "treadmill", label: "Treadmill" },
  ];

  const injuryOptions: Array<{ key: string; label: string }> = [
    { key: "lower_back", label: "Lower back" },
    { key: "knee", label: "Knee" },
    { key: "shoulder", label: "Shoulder" },
    { key: "wrist", label: "Wrist" },
    { key: "neck", label: "Neck" },
    { key: "hip", label: "Hip" },
    { key: "ankle", label: "Ankle" },
    { key: "elbow", label: "Elbow" },
  ];

  let selectedEquipment: Record<string, boolean> = {};
  let selectedInjuries: Record<string, boolean> = {};

  const toggleEquipment = (key: string): void => {
    selectedEquipment[key] = !selectedEquipment[key];
    selectedEquipment = selectedEquipment;
  };

  const toggleInjury = (key: string): void => {
    selectedInjuries[key] = !selectedInjuries[key];
    selectedInjuries = selectedInjuries;
  };

  const onClose = (): void => {
    // Demo only — nothing is saved.
    $dialogData.data = {};
    $dialogData.type = "";
  };
</script>

<div class="p-4 flex flex-col gap-5">
  <h3 class="text-center text-xl">Client Info</h3>
  <p class="text-center text-xs text-slate-500 dark:text-slate-400 -mt-3">
    Demo preview — selections are not saved.
  </p>

  <!-- Trains at home or gym -->
  <div class="flex flex-col gap-2">
    <p class="font-medium">Training location</p>
    <div class="flex flex-col gap-2 ml-2">
      <RadioField bind:group={trainingLocation} value="home">
        Trains at home
      </RadioField>
      <RadioField bind:group={trainingLocation} value="gym">
        Trains at gym
      </RadioField>
    </div>
  </div>

  <!-- Equipment (only when training at home) -->
  {#if trainingLocation === "home"}
    <div class="flex flex-col gap-2 pt-2 border-t border-slate-200 dark:border-zinc-600">
      <p class="font-medium">Available equipment</p>
      <div class="grid grid-cols-2 gap-x-4 gap-y-2 ml-2">
        {#each equipmentOptions as option}
          <!-- svelte-ignore a11y-click-events-have-key-events -->
          <!-- svelte-ignore a11y-no-static-element-interactions -->
          <div
            class="flex items-center cursor-pointer"
            on:click={() => toggleEquipment(option.key)}
          >
            <CheckboxComponent value={!!selectedEquipment[option.key]} />
            <span class="ml-2 text-sm">{option.label}</span>
          </div>
        {/each}
      </div>
    </div>
  {/if}

  <!-- Common injuries -->
  <div class="flex flex-col gap-2 pt-2 border-t border-slate-200 dark:border-zinc-600">
    <p class="font-medium">Most common injuries</p>
    <div class="grid grid-cols-2 gap-x-4 gap-y-2 ml-2">
      {#each injuryOptions as option}
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <!-- svelte-ignore a11y-no-static-element-interactions -->
        <div
          class="flex items-center cursor-pointer"
          on:click={() => toggleInjury(option.key)}
        >
          <CheckboxComponent value={!!selectedInjuries[option.key]} />
          <span class="ml-2 text-sm">{option.label}</span>
        </div>
      {/each}
    </div>
  </div>

  <div class="flex justify-center mt-2">
    <ButtonComponent on:click={onClose}>Close</ButtonComponent>
  </div>
</div>
